import { useDispatch } from 'react-redux';
import { FieldValues, useFormContext } from 'react-hook-form';
import { useCreateThirdPartyIntegration } from 'api/ThirdPartyIntegrationsAPI';
import { InputField, BorderedRadioListField } from 'lib/iterable-hook-form';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { fetchThirdPartyIntegrationsRequest } from '../actions';
import { useModalsContext, ThirdPartyIntegrationFormSchema } from '../contexts';
import { AnalyticsRegion } from '../types';
import { createRadioOptions } from '../utils';
import { ANALYTICS_REGION, API_TOKEN } from '../constants';
import { FlexContainer } from './CreateSegmentIntegrationModal.styled';

export const CreateSegmentIntegrationModal = () => {
  const { hideModal } = useModalsContext();
  const dispatch = useDispatch();

  const {
    handleSubmit,
    formState: { isValid, errors },
  } = useFormContext<ThirdPartyIntegrationFormSchema>();

  const { mutate: createThirdPartyIntegration } = useCreateThirdPartyIntegration({
    onSuccess: () => {
      hideModal();
      dispatch(fetchThirdPartyIntegrationsRequest());
    },
  });

  const onSubmit = (values: FieldValues) => {
    createThirdPartyIntegration(values);
  };

  return (
    <Modal
      id="create-segment-integration-modal"
      isModalOpen
      onClose={hideModal}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>New Segment integration</ModalHeader>
      <ModalBody>
        <form>
          <FormField
            labelText="Write key"
            inputId="write-key-input"
            errorText={errors?.[API_TOKEN]?.message}
            hasError={!!errors?.[API_TOKEN]}
          >
            <InputField id="write-key-input" name={API_TOKEN} autoFocus />
          </FormField>
          <FormField labelText="Region">
            <FlexContainer>
              {createRadioOptions(Object.values(AnalyticsRegion))?.map((option) => (
                <BorderedRadioListField
                  key={option.id}
                  name={ANALYTICS_REGION}
                  options={[option]}
                />
              ))}
            </FlexContainer>
          </FormField>
        </form>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          isDisabled={!isValid}
          onClick={handleSubmit(onSubmit)}
          size={BUTTON_SIZES.LARGE}
        >
          Create integration
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
